import { MedicalCamp } from "../../types/medicalCamp";
import { ENDPOINTS, getFullUrl } from "./config"

export class MedicalCampService {
  static getToken(): string | null {
    return localStorage.getItem("token")
  }
  static async addNewMedicalCamp(dataList: MedicalCamp) {
    try {      
      const response = await fetch(getFullUrl(ENDPOINTS.MEDICALCAMP.CREATE), {
        method: "POST",
        headers:
          {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.getToken()}`,
          },
        body:JSON.stringify(dataList),
        
      });

      const data = await response.json()
      return data

    } catch (error) {
      return {
        success: false,
        message:
          error instanceof Error ? error.message : "Failed to create medical camp",
      }
    }
  }
  static async updateExistingCamp(dataList: MedicalCamp) {
    try {      
      const response = await fetch(getFullUrl(ENDPOINTS.MEDICALCAMP.UPDATE), {
        method: "PUT",
        headers:
          {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.getToken()}`,
          },
        body: JSON.stringify(dataList)
      })

      const data = await response.json()
      return data
    } catch (error) {
      return {
        success: false,
        message:
          error instanceof Error ? error.message : "Failed to create clinic",
      };
    }
  }
  static async deleteMedicalCamp (medicalCampId:string){
    try {
      const response = await fetch(`${getFullUrl(ENDPOINTS.MEDICALCAMP.DELETE)}?id=${medicalCampId}&role=MedicalCamp` ,{
        method:"DELETE",
        headers:{
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      const data = response.json()
      return data
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Failed to delete Medical Camp",
      };
    }
  }

  static async getMedicalCamps({
    page = 1,
    pageSize = 10,
    searchText=""
  }: {
    page?: number;
    pageSize?: number;
    searchText: string;
  }): Promise<{
    success: boolean;
    message?: string;
    data?: {
      dataList: MedicalCamp[];
      totalPages: number;
      totalItemsCount: number;
      currentPage: number;
    };
  }> {
    try {
      const url = new URL(getFullUrl(ENDPOINTS.MEDICALCAMP.GETLIST))
      url.searchParams.append("page", page.toString())
      url.searchParams.append("pageSize", pageSize.toString())
      url.searchParams.append("searchText", searchText.toString())

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
      const data = await response.json()
      return data
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Failed to load Medical Camps",
      }
    }
  }
}